import { OrderWithItems, ShoppingCartWithItems } from 'common-models';
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetOrdersByVisitorIdQuery, useGetShoppingCartQuery } from "src/features/events/eventShopApiSlice";
import { useAppSelector } from "src/state/hooks";
import PageIsLoading from "../../components/PageIsLoading";
import { CheckoutCartView } from "../../components/checkout/CheckoutCartView";
import { selectVisitor } from "../../features/visitor/visitorSlice";

const StartCheckoutPage: FC<any> = () => {
    const visitor = useAppSelector(selectVisitor);

    const nav = useNavigate();

    const {
        data: ordersFromApi = undefined as unknown as Array<OrderWithItems>,
        isLoading: isOrderLoading,
    } = useGetOrdersByVisitorIdQuery(visitor.identifier);

    const { data: shoppingCartFromApi = undefined as unknown as ShoppingCartWithItems,
        isLoading: isCartLoading,
    } = useGetShoppingCartQuery([visitor.identifier, 'Open']);

    const [shoppingCart, setShoppingCart] = useState(undefined as unknown as ShoppingCartWithItems);

    useEffect(() => {
        if (!isOrderLoading && !isCartLoading) {
            // Both are done loading. First check if there was an order.
            if (ordersFromApi && ordersFromApi.length > 0) {
                nav({ pathname: `/checkout/${ordersFromApi[0].id}` })
            }
            else if (shoppingCartFromApi) {
                setShoppingCart(shoppingCartFromApi);
            }
        }
    }, [isOrderLoading, isCartLoading, ordersFromApi, shoppingCartFromApi, nav])

    function getCheckoutView() {

        if (shoppingCart) {
            return <CheckoutCartView cartId={shoppingCart.id} />
        }

        if (isCartLoading) {
            return <PageIsLoading />
        }
        return <>(Ingen varukorg hittades.)</>
    }

    return (
        <>
            {getCheckoutView()}
        </>
    );
    // }
};

export default StartCheckoutPage;
